import React, { useEffect } from "react";
import BreadcrumbsHeader from "../breadcrumbs/BreadcrumbsHeader";
import { Link } from "react-router-dom";
import Brands1 from "../brands/Brands1";
import { FaArrowRight } from "react-icons/fa";
import "aos/dist/aos.css";
import AOS from "aos";


const servicesData = [
  {
    title: "Bussiness Automation",
    icon: "/images/services/3199bc5d6a8a9e06751ea6d898289cf9.png",
    description:
      "Automating the business & company's workflow using technology to holistically enhance & upgrade company.",
    animation: "fadeInDown",
  },
  {
    title: "Mobile application",
    icon: "/images/services/mobile-app1.png",
    description:
      "Maximise your potential of reaching more perspective customers using a personalised interactive mobile app.",
    animation: "fadeInDown",
  },
  {
    title: "Web Application",
    icon: "/images/services/web-app1.png",
    description:
      "Creating business specific functionality within your website so as to provide your business with strong launching platform.",
    animation: "slideInRight",
  },
  {
    title: "CRM & ERP Solution",
    icon: "/images/services/crm.jpg",
    description:
      "Enhance your customer relationship management process with CRM and strategic business operations using Enterprise Resource Plannning.",
    animation: "slideInLeft",
  },
  {
    title: "Custom App Development",
    icon: "/images/services/custom-app.png",
    description:
      "Mapping your desires & custom requirements by developing interactive robust mobile apps.",
    animation: "fadeInUp",
  },
  {
    title: "Website Development",
    icon: "/images/services/web-develpment.png",
    description:
      "Get the official digital platform i.e. an interactive website developed for your company.",
    animation: "slideInRight",
  },
  {
    title: "Digital Payment Solution",
    icon: "/images/services/digital-payment.png",
    description:
      "Digitalise your business payments with a secure, reliable and instant cashless digital payment system.",
    animation: "slideInRight",
  },
  {
    title: "Ecommerce Solution",
    icon: "/images/services/Ecommerce-Solution.png",
    description:
      "Start the selling of your products and services with an online virtual shop. Get your ecommerce portal developed.",
    animation: "slideInRight",
  },
  {
    title: "Custom Software Development",
    icon: "/images/services/services_settings.png",
    description:
      "Solving your problems with software. Just share your problem & requirements to get a custom software developed.",
    animation: "slideInRight",
  },
];

const BusinessTechnology = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div>
      <BreadcrumbsHeader 
        title="Business Technology" 
        backgroundImage="/images/breadcrumbs/bussiness-technology.jpg" 
      />
 <section className="about-section section-home-secondary1">
      <div className="vertical-title hidden-md">
        <span className="vertical-text-main">ISOLS Group</span>
        <span className="vertical-text-additional">BT</span>
      </div>
      <div className="container">
        <div className="row">
          {/* Left Column: Text Content */}
          <div className="col-xs-12 col-sm-6 about-content">
            <div className="heading">
              <p className="first-heading">Empowering Businesses</p>
              <h1 className="heading-line">
                <strong>Through Technology</strong>
              </h1>
            </div>
            <div className="blockquote">
              <p className="quote-text">
              Business Technology is one of the areas of specialization of ISOLS Group developed & managed under its brand Innovative Solution Technologies.
              </p>
             
            </div>
            <div className="about-description">
              <p>
              Technology is one of the forte of ISOLS Group managed under its brand Innovative Solution Technologies. It focuses right from simple application development till business automation solution. The Company has its own technology products and solutions for various industry vertical such as Food & Restaurants, Hospitality, Medical & Healthcare, Doctors etc. Innovative Solution Technologies also offers its services for various custom software, mobile and web development requirements such as software development, website development, CRM development, mobile app development etc. The core niche of Innovative Solution Technologies is to conceptualize, develop & implement industry specific technology solution to solve the challenges of various industry verticals. Some of the technology solutions are:
              </p>
             
            </div>
          </div>
          {/* Right Column: Image */}
          <div className="col-xs-12 col-sm-6 about-image">
            <div className="img-brd-mod wow slideInRight">
                  <div className="brd"></div>
                  <div className="img-cut">
                    <div className="cut"></div>
                    <img src="/images/header/4.png" className="img-responsive center-block" alt="Isols working" />
                  </div>
              </div>
          </div>
        </div>
      </div>
    </section>
 <section className="section-services  pt-0 pb-5">
      <div className="container">
      <div className="b-services-holder">
          <div className="row">
            {servicesData.map((service, index) => (
              <div className={`col-xs-6 col-sm-4 wow ${service.animation}`}  key={index}>
                <div className="b-services-item">
                  <div className="services-icon">
                    <img src={service.icon} alt={service.alt} />
                  </div>
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      {service.title}
                    </h6>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="row">
       <div className="col-md-12">
        <div className="knowmorebtn">
          <Link to="/award-certifications" className="btn btn-default-arrow btn-sm">
          <FaArrowRight />
          Know more
          </Link>
          <p>about various technology solutions & services offered by Innovative Solution Technologies - A technology wing of ISOLS Group</p>
        </div>
        </div>
       </div>
      </div>
    </section>
   
   <Brands1 />
    </div>
  );
};

export default BusinessTechnology;
